import * as React from "react";
import {Box, Tooltip, Typography} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AgingTierScale from "./AgingTierScale";

export default function portfolioCellRenderers(theme) {
    const agingTierScale = AgingTierScale.default();
    return {
        status: (params) => <StatusCell tierCode={params.row.statusTierCode} label={params.value}
                                        color={agingTierScale.colorOf(params.row.statusTierCode, theme)}/>,
        orders: (params) => <OrdersCell hasOrderWithFutureDelivery={params.value}/>,
        risk: (params) => <RiskCell isHighRisk={params.value}/>,
    };
}

function StatusCell({tierCode, label, color}) {
    if (!tierCode) {
        return <CenteredCell><MutedDash/></CenteredCell>;
    }
    return (
        <CenteredCell>
            <Box sx={{
                display: 'inline-flex', alignItems: 'center', gap: '5px',
                fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '100px',
                backgroundColor: `${color}22`, color,
            }}>
                <Box sx={{width: 6, height: 6, borderRadius: '50%', backgroundColor: 'currentColor'}}/>
                {label}
            </Box>
        </CenteredCell>
    );
}

function OrdersCell({hasOrderWithFutureDelivery}) {
    return (
        <CenteredCell>
            {hasOrderWithFutureDelivery ? <Typography variant="body2">Sí</Typography> : <MutedDash/>}
        </CenteredCell>
    );
}

function RiskCell({isHighRisk}) {
    if (!isHighRisk) {
        return <CenteredCell><MutedDash/></CenteredCell>;
    }
    return (
        <CenteredCell>
            <Tooltip title="Alto riesgo: se bloquea ante cualquier mora, sin posibilidad de ampliar el crédito">
                <Box sx={{display: 'inline-flex', alignItems: 'center', gap: '5px', color: 'error.main', fontWeight: 700, fontSize: '12.5px'}}>
                    <WarningAmberIcon sx={{fontSize: 13}}/>
                    Alto
                </Box>
            </Tooltip>
        </CenteredCell>
    );
}

function CenteredCell({children}) {
    return <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>{children}</Box>;
}

function MutedDash() {
    return <Typography variant="body2" sx={{color: 'text.secondary'}}>—</Typography>;
}
